import notify from '@/modules/notify';

const clear = () => {
  document.querySelectorAll('[data-notify]').forEach((item) => item.remove());
};

document.addEventListener('turbo:before-cache', clear);

export default () => {
  if (document.documentElement.hasAttribute('data-turbo-preview')) return;

  document.querySelectorAll('[data-notify]').forEach((item) => {
    notify({ body: item.dataset.notifyBody, title: item.dataset.notifyTitle });

    item.remove();
  });
};
